import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import { defaultLang } from "@/lib/articles";

export default function NotFound() {
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <Header lang={defaultLang} />
      <main className="flex-1 flex flex-col items-center justify-center text-center px-4">
        <h1 className="text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none">
          404
        </h1>
        <div className="relative z-10 -mt-10 md:-mt-16">
          <h2 className="text-xl md:text-2xl font-semibold text-foreground-900">
            {t("notFound.title")}
          </h2>
          <p className="mt-2 text-base text-foreground-500 font-mono">{location.pathname}</p>
          <p className="mt-4 text-lg md:text-xl text-foreground-600">
            {t("notFound.subtitle")}
          </p>
          <Link
            to={`/${defaultLang}`}
            className="inline-flex items-center gap-2 mt-6 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 px-5 py-3 text-sm font-semibold whitespace-nowrap transition-colors"
          >
            <i className="ri-arrow-left-line"></i>
            {t("notFound.backHome")}
          </Link>
        </div>
      </main>
      <Footer lang={defaultLang} />
    </div>
  );
}